<!--
 * @Date: 2020-05-19 15:46:02
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-05-27 18:49:50
 * @FilePath: /xy-pc/src/views/userCenter/myCourse/orgclassDetail.vue
--> 

<template>
  <div class="student_myclass "  style="width:100%">
    <el-tabs v-model="activeName">
      <el-tab-pane disabled name="first">
        <el-breadcrumb slot="label" style="margin-top: 13px;" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orglist' }">我的课程</el-breadcrumb-item>
          <el-breadcrumb-item>课程详情</el-breadcrumb-item>
        </el-breadcrumb>
      </el-tab-pane>
    </el-tabs>

    <el-row :gutter="20">
      <el-col :span="10">
        <el-image style="width:100%; height:150px" :src="courseInfo.thumb_image" fit="cover"></el-image>
      </el-col>
      <el-col :span="14">
        <el-form label-width="80px" label-position="left" size="small">
          <div class="goodsTit">{{courseInfo.name}}</div>
          <el-form-item>
            <span class="subTit" slot="label">时间：</span>
            {{courseInfo.begin_at}}~{{courseInfo.end_at}}
          </el-form-item>
          <el-form-item>
            <span class="subTit" slot="label">岗位：</span>
            <div class="jobContent" :class="[{'desc-more ellipsis-2': !isShowMoreDesc}]">
              <span
                style="margin-right:5px"
                v-for="(item ,index) in courseInfo.duties"
                :key="index"
              >{{item}}</span>
              <span class="arrowUp" v-if="!isShowMoreDesc&&courseInfo.duties.join(' ').length>50">
                <i @click="isShowMoreDesc=true" class="el-icon-arrow-down"></i>
              </span>
            </div>
          </el-form-item>
          <el-form-item>
            <span class="subTit" slot="label">课程：</span>
            {{courseInfo.courses.length}}节
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div class="clearfix" style="padding:10px 0">
      <span class="nubTit">专家：</span>
      <div style="display:inline-block;vertical-align: middle;">
        <div class="avaBox" v-for="(item,index) in courseInfo.experts" :key="index">
          <el-image style="width:40px;height:40px;border-radius:20px" :src="item.avatar"></el-image>
          <div class="avaName">{{item.real_name}}</div>
        </div>
      </div>
    </div>
    <div class="courseDetail">
      <div class="courseHead">班级学员及课程进度：</div>
      <div class="courseContent">
        <div class="courseItem" v-for="(item,index) in stationUser" :key="index">
          <div class="userBox" @click="getProgress(item)">
            <span class="userAvatar">
              <el-image style="width:40px;height:40px;border-radius:20px" :src="item.user.avatar"></el-image>
            </span>
            <span class="userName">{{item.user.name}}</span>
          </div>
          <div v-if="activeId==item.id">
            <div class="chapter" v-for="(items,index) in courseProcess" :key="index">
              <p class="chaTit">{{items.title}}</p>
              <el-progress
                :text-inside="true"
                :stroke-width="20"
                :percentage="items.process>=100?100:(items.process-0).toFixed(2)"
              ></el-progress>
              <div
                class="course_list clearfix"
                v-for="(itemc,indexs) in items.videos"
                :key="indexs"
              >
                <div class="course_head">{{itemc.title}}</div>
                <div class="course_study">{{itemc.status==1?"完成":itemc.status==-1?'学习中':'未学习'}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "orgclassDetail",
  data() {
    return {
      courseId: "",
      activeId: "",
      activeTab: 1,
      isShowMoreDesc: false,
      stationUser: [],
      courseInfo: {
        score: "",
        thumb_image: "",
        introduce: "",
        end_at: "",
        duties: [],
        begin_at: "",
        courses: [{ title: "asfdasd", expert: {} }],
        category_name: "",
        chapters: "",
        describe: "",
        expert: "",
        is_buy: "",
        price: "",
        realy_price: "",
        title: "",
      },
      courseProcess: [], //课程进度
      activeName: "first",
    };
  },

  created() {},
  activated() {
    if (this.$route.query && this.$route.query.id) {
      this.courseId = this.$route.query.id;
      this.getClassDetail();
    } else {
      console.log(1);
    }
  },

  methods: {
    getClassDetail(id) {
      this.$http({
        url: "/api/v1/auth/classes/station-read/" + this.courseId,
        method: "get",
      })
        .then((res) => {
          if (res.status == 200) {
            this.courseInfo = Object.assign(
              this.courseInfo,
              {},
              res.data.userCourse.classes
            );
            this.stationUser = res.data.userCourse.station_user_courses;
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("系统错误");
        });
    },
    getProgress(item) {
      this.activeId = item.id;
      this.courseProcess = [];
      this.$http({
        url: "api/v1/auth/classes/station-process/" + item.id,
        method: "get",
        params: {
          user_id: item.user.id,
          user_course_id: this.courseId,
        },
      }).then((res) => {
        if (res.status == 200) {
          this.courseProcess = res.data.station_user_course.course.chapters;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.Personal {
  background: #fff;
}
.chapter {
  padding-bottom: 20px;
  .chaTit {
    padding: 10px 0;
  }
}
.jobContent {
  cursor: pointer;
  line-height: 34px;
  position: relative;
  .arrowUp {
    width: 80px;
    height: 34px;
    text-align: right;
    padding-right: 10px;
    position: absolute;
    display: inline-block;
    background: linear-gradient(to right, rgba(255, 255, 255, 0.1), #fff, #fff);
    right: 0;
    bottom: 0;
  }
}
.arrowUp {
}
.desc-more {
  position: relative;
  height: 50px;

  overflow: hidden;
}
.courseDetail {
  margin-top: 10px;
  border: rgba(229, 229, 229, 1) solid 1px;
  .courseHead {
    height: 70px;
    border-bottom: rgba(229, 229, 229, 1) solid 1px;
    text-align: left;
    line-height: 70px;
    padding-left: 28px;
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
  }
  .courseContent {
    padding: 20px;
    min-height: 400px;
  }
  .userBox {
    height: 45px;
    margin: 15px 0;
    line-height: 45px;
    color: rgba(0, 0, 0, 1);
    font-size: 23px;
    vertical-align: middle;
    cursor: pointer;
  }
  .userAvatar {
    vertical-align: middle;
    display: inline-block;
    line-height: 40px;
    height: 40px;
  }
  .userName {
    vertical-align: middle;
    margin-left: 10px;
    line-height: 40px;
    height: 40px;
    display: inline-block;
  }
}

.Personal_left {
  width: 140px;
  height: 315px;
  left: 415px;
  top: 70px;
  position: relative;
}
.contant {
  width: 960px;
  height: 414px;
  left: 615px;
  top: -240px;
  position: relative;
}
.nubTit {
  width: 68px;
  opacity: 0.88;
  color: rgba(80, 80, 80, 1);
  font-size: 19px;
  margin-right: 29px;
}
.goodsTit {
  color: rgba(80, 80, 80, 1);
  font-size: 20px;
  line-height: 1.5;
  text-align: left;
  font-weight: bold;
}
.avaBox {
  float: left;
  margin-right: 21px;
  text-align: center;
}
.avaName {
  height: 21px;

  color: rgba(153, 153, 153, 1);
  font-size: 12px;
}
.Personal_hen {
  width: 960px;
  height: 1px;
  color: rgba(80, 80, 80, 1);
  background-color: rgba(153, 153, 153, 1);
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  position: relative;
  top: -25px;
}

.subTit {
  color: rgba(128, 128, 128, 1);
  font-size: 18px;
  margin-top: 15px;
  font-weight: 700;
}
.ellipsis-1 {
  width: 609px;
  height: 37px;
  color: rgba(0, 0, 0, 1);
  font-size: 20px;
  line-height: 150%;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  float: left;
}
.header img {
  width: 343px;
  height: 187px;
  float: left;
  margin-right: 50px;
}
.post {
  width: 356px;
  height: 34px;
  color: rgba(128, 128, 128, 1);
  font-size: 18px;
  line-height: 150%;
  text-align: left;
  margin-top: 10px;
  float: left;
}

.time {
  width: 357px;
  height: 34px;
  left: 934px;
  top: 411px;
  color: rgba(128, 128, 128, 1);
  font-size: 18px;
  line-height: 150%;
  text-align: left;
  float: left;
  margin-top: 10px;
}
.curriculum {
  width: 345px;
  height: 34px;
  color: rgba(128, 128, 128, 1);
  font-size: 19px;
  line-height: 150%;
  text-align: left;
  float: left;
  margin-top: 10px;
}

.expert img {
  width: 52px;
  height: 52px;
  border-radius: 50%;
}
.expert_list {
  width: 52px;
  text-align: center;
  float: left;
  margin-right: 20px;
}
.expertImg {
  width: 40px;
  height: 40px;
  border-radius: 20px;
}
.expert {
  overflow: hidden;
  width: 1020px;
  padding-top: 20px;
}
.expert_name {
  width: 68px;
  height: 41px;
  left: 0;
  top: 20px;
  opacity: 0.88;
  color: #505050;
  font-size: 19px;
  line-height: 150%;
  text-align: center;
  float: left;
  position: relative;
  margin-right: 35px;
}
.detail {
  width: 968px;
  height: 750px;
  color: rgba(80, 80, 80, 1);
  background-color: rgba(255, 255, 255, 0.6);
  font-size: 15px;
  line-height: 150%;
  border: rgba(166, 166, 166, 0.6) solid 1px;
  text-align: center;
  margin-top: 30px;
}
.course_list:first-child {
  margin-top: 50px;
}
.course_list {
  width: 100%;
  margin: 15px auto;
}
.course_head {
  width: 486px;
  height: 37px;
  color: rgba(56, 56, 56, 1);
  font-size: 17px;
  line-height: 37px;
  text-align: left;
  float: left;
}
.course_study {
  height: 37px;
  color: rgba(43, 188, 102, 1);
  font-size: 16px;
  line-height: 37px;
  text-align: left;

  float: left;
}
.course_time {
  width: 143px;
  height: 25px;
  color: rgba(43, 188, 102, 1);
  font-size: 17px;
  line-height: 150%;
  float: left;
  text-align: left;
}
.course_jin {
  width: 399px;
  height: 13px;
  color: rgba(80, 80, 80, 1);
  background-color: rgba(233, 233, 233, 1);
  box-shadow: rgba(203, 203, 203, 1) solid 1px;
  border-radius: 9px;
  font-size: 20px;
  line-height: 150%;
  float: right;
  text-align: center;
  div {
    width: 68px;
    height: 13px;
    color: rgba(80, 80, 80, 1);
    background-color: rgba(43, 188, 102, 1);
    border-radius: 9px;
    font-size: 20px;
    line-height: 150%;
    text-align: center;
  }
}
.introduce_head {
  width: 126px;
  height: 27px;
  left: 990px;
  top: 792px;
  letter-spacing: 7px;
  color: rgba(0, 0, 0, 1);
  font-size: 21px;
  line-height: 150%;
  text-align: left;
  font-weight: bold;
  margin: 0 auto;
  margin-top: 20px;
}
.introduce_detail {
  width: 854px;
  height: 371px;
  left: 626px;
  top: 894px;
  color: rgba(80, 80, 80, 1);
  font-size: 16px;
  line-height: 150%;
  text-align: left;
  margin: 0 auto;
  margin-top: 20px;
}
</style>